var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.toggleClick}},[_c('svg-icon',{staticClass:"hamburger",class:{'is-active':_vm.isActive},attrs:{"icon-class":_vm.svgName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }